import { getAgentId } from 'utils/getValue';

// 交行全网络要隐藏的休息室
const bankcomm_all = [
  'N01530',
  'N01120',
  'N02076',
  'N04002',
  'N02134',
  'N03260',
  'N03028',
  'N01746',
  'N01547',
  'N04680',
  'N02816',
  'N01105',
  'N00305',
  'N03394',
  'N03257',
  'N03258',
  'N01144',
  'N00295',
  'N02909',
  'N02906',
  'N01736',
  'N00767',
  'N00768',
  'N04552',
  'N03115',
  'N04330',
  'N00270',
  'N00263',
  'N02794',
  'N01505',
  'N02903',
  'N02904',
  'N02940',
  'N02478',
  'N03043',
  'N02949',
  'N01739',
  'N04234',
  'N00048',
  'N01701',
  'N00653',
  'N00036',
  'N00031',
  'N00030',
  'N01700',
  'N01170',
  'N00049',
  'N03263',
  'N01310',
  'N00096',
  'N04217',
  'N04438',
  'N02370',
  'N02768',
  'N00754',
  'N04441',
  'N03716',
  'N04098',
  'N04707',
  'N04383',
  'N00576',
  'N04634',
  'N02853',
  'N01466',
  'N04527',
  'N00563',
  'N04819',
  'N00339',
  'N04126',
  'N04202',
  'N02357',
  'N00166',
  'N04525',
  'N01642',
  'N01131',
  'N00165',
  'N03737',
  'N03662',
  'N03092',
  'N04048',
  'N01810',
  'N02373',
  'N00015',
  'N02211',
  'N01903',
  'N00320',
  'N04681',
  'N01925',
  'N01922',
  'N00085',
  'N00083',
  'N04125',
  'N03054',
  'N01286',
  'N00312',
  'N00684',
  'N00664',
  'N01923',
  'N01242',
  'N01156',
  'N01155',
  'N04073',
  'N03345',
  'N01657',
  'N01346',
  'N00738',
  'N00737',
  'N04550',
  'N01183',
  'N00407',
  'N02923',
  'N04113',
  'N01176',
  'N04285',
  'N02945',
  'N03544',
  'N03359',
  'N03755',
  'N02266',
  'N04592',
  'N00718',
  'N01283',
  'N04145',
  'N01250',
  'N02281',
  'N01756',
  'N00116',
  'N04529',
  'N00871',
  'N00598',
  'N04471',
  'N00279',
  'N01118',
  'N00632',
  'N01902',
  'N03678',
  'N03677',
  'N03417',
  'N04609',
  'N02004',
  'N00423',
  'N04349',
  'N04269',
  'N03756',
  'N01342',
  'N00115',
  'N00109',
  'N01783',
  'N01180',
  'N01178',
  'N04328',
  'N04136',
  'N03309',
  'N02631',
  'N00770',
  'N03609',
  'N00439',
  'N03497',
  'N01597',
  'N00806',
  'N01706',
  'N01705',
  'N04399',
  'N04225',
  'N04112',
  'N04601',
  'N01343',
  'N04683',
  'N01048',
  'N00268',
  'N00266',
  'N04710',
  'N03099',
  'N00949',
  'N00948',
  'N00865',
  'N02843',
  'N04602',
  'N03513',
  'N01289',
  'N00557',
  'N02202',
  'N02058',
  'N04288',
  'N02736',
  'N01655',
  'N04187',
  'N04188',
  'N04064',
  'N04540',
  'N01356',
  'N04687',
  'N04068',
  'N03691',
  'N04528',
  'N01111',
  'N03643',
  'N01197',
  'N00643',
  'N00615',
  'N03331',
  'N04553',
  'N01919',
  'N03035',
  'N03664',
  'N00510',
  'N04404',
  'N04607',
  'N04603',
  'N04224',
  'N03066',
  'N00375',
  'N00244',
  'N02957',
  'N04263',
  'N03759',
  'N04372',
  'N03601',
  'N04384',
  'N04385',
  'N03680',
  'N00698',
  'N00078',
  'N00081',
  'N00073',
  'N04321',
  'N04714',
  'N03082',
  'N05075',
  'N01997',
  'N04313',
  'N04314',
  'N04315',
  'N04316',
  'N04317',
  'N04318',
  'N04312',
  'N04309',
  'N00408',
  'N04081',
  'N04598',
  'N00435',
  'N00143',
  'N00146',
  'N03030',
  'N02468',
  'N01809',
  'N00209',
  'N02824',
  'N02089',
  'N04989',
  'N03299',
  'N03156',
  'N03329',
  'N03488',
  'N00878',
  'N00184',
  'N02362',
  'N01625',
  'N04147',
  'N04141',
  'N03061',
  'N03139',
  'N00348',
  'N04282',
  'N04279',
  'N03017',
  'N02314',
  'N02315',
  'N02088',
  'N00868',
  'N00022',
];
// 交行优逸卡隐藏的网络
const bankcomm_yyk = [
  'N03028',
  'N03115',
  'N04330',
  'N01170',
  'N00049',
  'N00096',
  'N00576',
  'N00563',
  'N04202',
  'N02357',
  'N00166',
  'N01642',
  'N01131',
  'N00165',
  'N03737',
  'N03662',
  'N03092',
  'N01810',
  'N02373',
  'N00015',
  'N02211',
  'N01903',
  'N00085',
  'N00083',
  'N03054',
  'N01286',
  'N01242',
  'N01156',
  'N01155',
  'N04073',
  'N03345',
  'N01657',
  'N01346',
  'N00738',
  'N00737',
  'N04285',
  'N03359',
  'N02266',
  'N00718',
  'N01283',
  'N04145',
  'N01250',
  'N02281',
  'N01756',
  'N00116',
  'N00871',
  'N00598',
  'N01118',
  'N01902',
  'N04609',
  'N02004',
  'N00423',
  'N04349',
  'N04269',
  'N03756',
  'N01342',
  'N00115',
  'N00109',
  'N01783',
  'N01180',
  'N01178',
  'N04328',
  'N04136',
  'N03309',
  'N02631',
  'N00770',
  'N03609',
  'N00439',
  'N03497',
  'N01597',
  'N00806',
  'N01706',
  'N01705',
  'N04399',
  'N04601',
  'N01343',
  'N03099',
  'N00949',
  'N00948',
  'N00865',
  'N02843',
  'N04602',
  'N00557',
  'N02202',
  'N02058',
  'N04288',
  'N02736',
  'N01655',
  'N04187',
  'N04188',
  'N04064',
  'N04540',
  'N01356',
  'N04687',
  'N04068',
  'N03691',
  'N01111',
  'N01197',
  'N00643',
  'N04553',
  'N03664',
  'N00510',
  'N04404',
  'N04607',
  'N04603',
  'N03066',
  'N00375',
  'N03601',
  'N03680',
  'N00698',
  'N00078',
  'N00081',
  'N00073',
  'N04321',
  'N04714',
  'N03082',
  'N05075',
  'N01997',
  'N04313',
  'N04314',
  'N04315',
  'N04316',
  'N04317',
  'N04318',
  'N04312',
  'N04309',
  'N04081',
  'N04598',
  'N00435',
  'N00143',
  'N00146',
  'N03030',
  'N02468',
  'N01809',
  'N00209',
  'N03156',
  'N03329',
  'N03488',
  'N00878',
  'N00184',
  'N02362',
  'N01625',
  'N04147',
  'N04141',
  'N03061',
  'N03139',
  'N00348',
  'N04282',
  'N04279',
  'N03017',
  'N02314',
  'N02315',
];
// 交行世界极卡
const bankcomm_sjjk = [
  'N02370',
  'N01530',
  'N02076',
  'N04002',
  'N02768',
  'N02134',
  'N00754',
  'N00563',
  'N04819',
  'N03028',
  'N04202',
  'N00166',
  'N01746',
  'N00320',
  'N01547',
  'N04681',
  'N04680',
  'N00083',
  'N00312',
  'N01105',
  'N00684',
  'N00664',
  'N00305',
  'N00302',
  'N03345',
  'N01657',
  'N00407',
  'N02923',
  'N00762',
  'N01176',
  'N02929',
  'N00295',
  'N02281',
  'N00598',
  'N00279',
  'N00654',
  'N03417',
  'N04609',
  'N03115',
  'N01180',
  'N03309',
  'N04330',
  'N00270',
  'N00268',
  'N00263',
  'N04187',
  'N01111',
  'N00615',
  'N02478',
  'N02949',
  'N04234',
  'N02957',
  'N01701',
  'N00653',
  'N00036',
  'N00031',
  'N00030',
  'N01700',
  'N00078',
  'N00081',
  'N04321',
  'N01170',
  'N00049',
  'N00408',
  'N00146',
  'N00209',
  'N00096',
  'N04217',
  'N04989',
  'N04279',
  'N02088',
  'N00868',
  'N00022',
];
const getHideLoungeArr = () => {
  const agentId = getAgentId();
  const bankcommAllAgentId = [
    '12763',
    '17491',
    '19395',
    '19396',
    '19397',
    '22124',
    '24440',
    '5278',
    '5279',
    '5280',
    '5284',
    '5295',
    '5315',
    '6382',
    '6401',
    '7122',
  ];
  const bankcommYkkAgentId = ['9048', '9356'];
  const bankcommSJJKAgentId = ['38620'];
  if (bankcommAllAgentId.includes(agentId)) {
    return bankcomm_all;
  }
  if (bankcommYkkAgentId.includes(agentId)) return bankcomm_yyk;
  if (bankcommSJJKAgentId.includes(agentId)) return bankcomm_sjjk;
  return [];
};

export default getHideLoungeArr;
